module.exports = __webpack_public_path__ + "static/media/top_banner_7.feddd16f.png";